import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState } from 'react'
import { classNames, ModalProps } from '../../../utils/utils'
import { CancelIcon } from '../../../utils/iconFactory'
import { useTheme } from '../../../utils/themeUtils'
import { SearchInput } from '../../Elements/CustomInputs'
import { DocumentData } from '../../../utils/state'
import { DocumentCardSmall } from '../../DocumentComopnents'

interface SelectDocumentProps extends ModalProps {
  loadedDocuments: DocumentData[]
  handleChangeDocument: (id:string) => void;
}

export default function SelectDocumentModal({ isVisible, onClose, loadedDocuments, handleChangeDocument }: SelectDocumentProps) {
  const { themeString } = useTheme()
  const [searchQuery, setSearchQuery] = useState<string>('');

  const filteredDocuments = loadedDocuments.filter((document) => {
    const { name, data } = document;
    const lowerCaseSearchQuery = searchQuery.toLowerCase();

    return (
      name.toLowerCase().includes(lowerCaseSearchQuery) ||
      // contentType.toLowerCase().includes(lowerCaseSearchQuery) ||
      (data && data.toLowerCase().includes(lowerCaseSearchQuery))
    );
  });

  return (
    <>
      <Transition appear show={isVisible} as={Fragment}>
        <Dialog as="div" className={classNames("relative z-40", themeString)} onClose={onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative h-[518px] w-[840px] rounded-[22px] bg-backgroundWhite py-8 text-left align-middle transform transition-all overflow-hidden modal-shadow">
                  <Dialog.Title
                    as="h3"
                    className="text-textMain text-style-h3 border-b border-gray10 pb-4 ml-8 mr-6 overflow-hidden"
                  >
                    Dokumentumok
                  </Dialog.Title>
                  <button className='absolute top-9 right-6' onClick={onClose}>
                    <CancelIcon className='h-6 w-6 text-gray100 fill-current' />
                  </button>

                  <div id='content' className="flex-col max-h-full pl-8 pr-6 pt-6 overflow-y-auto no-scrollbar">
                    <p className="text-textMain text-style-body2">Kattints arra a dokumentumra, melyet be szeretnél tölteni.</p>
                    <div className='pt-[22px]'>
                      <SearchInput
                        type="text"
                        value={searchQuery}
                        customAction={() => setSearchQuery("")}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Keresés..."
                        spellCheck={false}
                      />
                    </div>
                    <div id='document-card-section' className="pt-[26px] pb-[32px] flex flex-wrap gap-4 w-full" >
                      {filteredDocuments.map((item, index) => (
                        <DocumentCardSmall
                          key={index}
                          item={item}
                          handleChangeDocument={(id:string) => {handleChangeDocument(id); onClose()}}
                        />
                      ))}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
